/* Presentation-only guide. The original app nodes, requirements and redemption handlers stay intact. */
(() => {
  function start() {
    const root = document.querySelector('[data-tq-rewards]');
    if (!root || root.dataset.guideReady) return;
    const picker = root.querySelector('.tq-reward-picker');
    const copy = root.querySelector('.tq-guide-data')?.dataset;
    const panels = [...root.querySelectorAll('.tq-reward-shell')];
    if (!picker || !copy || !panels.length || panels.some(panel => !panel.querySelector('.trading-cards__prize .trading-cards__js-open-prize-modal'))) return;
    root.dataset.guideReady = 'true';
    const giftLabel = JSON.parse(document.getElementById('dac-treasure-translations').textContent).prizes.gift_card;
    const buttons = panels.map((panel, index) => {
      const prize = panel.querySelector('.trading-cards__prize');
      const header = prize.querySelector('.trading-cards__header');
      const custom = panel.hasAttribute('data-tq-custom');
      const button = document.createElement('button');
      button.type = 'button';
      button.id = `tq-choice-${index + 1}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', `tq-reward-${index + 1}`);
      const amount = document.createElement('span');
      amount.className = 'tq-choice-amount';
      amount.textContent = custom ? copy.custom : header.querySelector('.trading-cards__prize-amount').textContent.trim();
      button.append(amount);
      if (!custom) {
        const label = document.createElement('span');
        label.className = 'tq-choice-label';
        label.textContent = giftLabel;
        button.append(label);
      } else button.classList.add('tq-choice-custom');
      picker.append(button);
      panel.id = `tq-reward-${index + 1}`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', button.id);
      panel.tabIndex = 0;
      if (!custom) {
        const art = document.createElement('div');
        art.className = 'tq-guide-art';
        art.append(header, panel.querySelector('.tq-reward-story'));
        const content = document.createElement('div');
        content.className = 'tq-guide-content';
        content.append(...prize.childNodes);
        prize.append(art, content);
      }
      const requirements = prize.querySelector('.trading-cards__requirements > p');
      if (requirements) requirements.textContent = copy.collect;
      const redeem = prize.querySelector('.trading-cards__js-open-prize-modal');
      redeem.textContent = copy.enter;
      const note = document.createElement('p');
      note.className = 'tq-guide-session';
      note.textContent = copy.session;
      // Keep the custom artwork-guidelines link beside the native redeem control.
      redeem.after(note);
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % panels.length;
        else if (event.key === 'ArrowLeft') next = (index + panels.length - 1) % panels.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = panels.length - 1;
        else return;
        event.preventDefault();
        select(next);
        buttons[next].focus();
      });
      return button;
    });
    function select(index) {
      panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        buttons[i].setAttribute('aria-selected', String(i === index));
        buttons[i].tabIndex = i === index ? 0 : -1;
      });
    }
    select(0);
    picker.hidden = false;
    root.classList.add('tq-guided');
    function reveal(hash) {
      if (!hash?.startsWith('#')) return;
      const target = document.getElementById(hash.slice(1));
      if (!target) return;
      const panel = target.closest('.tq-reward-shell');
      if (panel) select(panels.indexOf(panel));
      if (target.matches('details')) target.open = true;
      let parent = target.parentElement;
      while (parent) {
        if (parent.matches('details')) parent.open = true;
        parent = parent.parentElement;
      }
    }
    document.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (anchor) reveal(anchor.getAttribute('href'));
    }, true);
    window.addEventListener('hashchange', () => reveal(location.hash));
    reveal(location.hash);
  }
  // The base flow enhancement registers first and retains ownership of dialogs and card validation.
  if (document.readyState === 'loading' || document.readyState === 'interactive') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
